import { render } from "./m-edit-client.vue?vue&type=template&id=5e1720c4"
import script from "./m-edit-client.vue?vue&type=script&lang=js"
export * from "./m-edit-client.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__